export default "__VITE_ASSET__Ck$WaCGm__"